import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { TextGroup } from "../../../commonStyles";
import { FlexRow } from "../Styles";

export const VotedFeedBack = ({
  votedUsersCount,
}: {
  votedUsersCount: number;
}) => {
  const { typography, Color } = useTheme();

  return (
    <Container $gapInPx={8}>
      <IconWrapper>
        <Components.Icon type="ThumbsUp" size="16px" />
      </IconWrapper>
      <TextGroup>
        <Components.Text
          text={votedUsersCount > 1 ? `You and ` : `You have `}
          style={{ tokenStyle: typography.Body.M }}
        />
        {votedUsersCount > 1 && (
          <Components.Text
            text={`${votedUsersCount - 1} `}
            style={{ tokenStyle: typography.Body.M }}
            color={Color.text["text-emphasize-brand"].value}
            fontWeight="font-weight-semibold"
          />
        )}
        {votedUsersCount > 1 && (
          <Components.Text
            text={`other${votedUsersCount > 2 ? "s" : ""} have `}
            style={{ tokenStyle: typography.Body.M }}
          />
        )}
        <Components.Text
          text={`voted! See all results below.`}
          style={{ tokenStyle: typography.Body.M }}
        />
      </TextGroup>
    </Container>
  );
};
const IconWrapper = styled.div`
  padding-top: 2px;
`;
const Container = styled(FlexRow)(
  ({ theme }) => `
  align-items: baseline;
  border-radius: ${theme.radius["radius-xs"].value}rem;
  border: ${theme.border_width["border-width-thin"].value}rem solid ${theme.Color.border["ui-border-primary-subtle"].value};
  padding: ${theme.spacing["spacing-4"].value}rem;
  background: ${theme.Color.background.neutral.subtle.default.value};
  align-items: baseline;
  `
);
